import { createClient } from '@supabase/supabase-js';
import { normalizeRestaurantPhone } from './restaurantPhone';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Configurazione Supabase pubblica mancante');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export async function signUpRecover({ email, password, ownerName, restaurantName, city, phone, entryPoint }) {
  const contactPhone = normalizeRestaurantPhone(phone);
  const siteUrl = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, '');
  return supabase.auth.signUp({
    email: email.trim(),
    password,
    options: {
      data: {
        nome: ownerName.trim(),
        nome_ristorante: restaurantName.trim(),
        citta: city.trim(),
        telefono: contactPhone,
        product: 'recover',
          // Navigation preference only; never used to grant access.
          ...(entryPoint === 'menu' ? { entry_point: 'menu' } : {}),
      },
      emailRedirectTo: `${siteUrl}/app`,
    },
  });
}

export function signInRecover(email, password) {
  return supabase.auth.signInWithPassword({ email: email.trim(), password });
}

export function signOutRecover() {
  return supabase.auth.signOut();
}

export function requestRecoverPassword(email) {
  const siteUrl = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, '');
  return supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo: `${siteUrl}/app?reset=1` });
}

export function updateRecoverPassword(password) {
  return supabase.auth.updateUser({ password });
}
